import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { useParams, useNavigate, Link } from "react-router-dom";

import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import ModifiersmangeTableRows from "./ModifiersTableRows";

const Modifiersmange = (props) => {
  let navigate = useNavigate();
  const paramObject = useParams();
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [CostPriceValidation, setCostPriceValidation] = useState(true);
  const [SellingPriceValidation, setSellingPriceValidation] = useState(true);
  const [rowsData, setRowsData] = useState([
    {
      ID: 0,
      Name: "",
      CostPrice: (0.0).toFixed(2),
      SellingPrice: (0.0).toFixed(2),
    },
  ]);
  // const [id, setId] = useState([0]);
  const [formValues, setFormValues] = useState({ Name: "" });

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
  });

  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");

  const addTableRows = () => {
    const rowsInput = {
      ID: 0,
      Name: "",
      CostPrice: (0.0).toFixed(2),
      SellingPrice: (0.0).toFixed(2),
    };
    setRowsData([...rowsData, rowsInput]);
  };
  const handleChangeTableRow = (index, evnt) => {
    const { name, value } = evnt.target;

    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  };

  const deleteTableRows = (index) => {
    console.log(index);
    const rows = [...rowsData];
    console.log(rows);
    rows.splice(index, 1);
    console.log(rows);
    setRowsData(rows);
  };

  const handleSubmit = (values) => {
    const jsonobj = {};
    jsonobj.ModifiersitemsXML = rowsData;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);
    axios
      .post(
        `${config.modifiersBaseUrl}/modifiers/upsert`,
        {
          modifiersitemsxml: jsonstring,
          id: paramObject.id || 0,
          name: values.Name,
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/modifiers-list");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);

      })
      .catch((error) => {


        setLoading(false);
      });
  };

  useEffect(() => {
    if (paramObject.id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.modifiersBaseUrl}/modifiers/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const itemdata = res.data.ResponseData.Item;
          formValues.Name = res.data.ResponseData.Modifier[0].Name;
          setRowsData(itemdata);
          setLoading(false);
        })
        .catch((err) => {

          setLoading(false);
        });
    }
  }, []);

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header" 
           style={{
            position: "fixed",
            top: "2px",
            zIndex: "999",
          }}
          >
            <div className="row breadcrumb-position" >
              {/* <h3 className="page-title">Modifiers</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/modifiers-list">Modifiers List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Modifiers</li>
              </ul>
            </div>
          </div>
          <div className="card card-body">
            <div className="card-header">
              <h5 className="card-title">Manage Modifiers</h5>
            </div>
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="row mb-3">
                          <label className="col-form-label col-md-2 col-form-label p-lg-medium">
                            Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-10">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${errors.Name ? "is-invalid" : ""
                                }`}
                              id="Name"
                              name="Name"
                              onChange={handleChange}
                            />
                            <div className="invalid-feedback">
                              {touched.Name && errors.Name ? errors.Name : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* dynamic field */}
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group row">
                          <label className="col-form-label col-md-2 col-form-label p-lg-medium">
                            Item
                          </label>
                          <div className="col-md-10">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th width="30%" className="p-regular">Name</th>
                                    <th width="30%" className="p-regular">Cost Price</th>
                                    <th width="30%" className="p-regular">Selling Price</th>
                                    <th width="10%" className="p-regular">Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <ModifiersmangeTableRows
                                    rowsData={rowsData}
                                    deleteTableRows={deleteTableRows}
                                    handleChange={handleChangeTableRow}
                                  />
                                </tbody>
                              </table>
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-secondary pull-left mt-3"
                              onClick={addTableRows}
                            >
                              <i className="fa fa-plus fa-sm" /> Add
                            </button>
                          </div>
                          <div>
                            <div className="pull-right">
                              <button
                                type="submit"
                                className="btn btn-sm btn-primary mt-3 me-3"
                              >
                                Save
                              </button>
                              <Link
                                to="/modifiers-list"
                                className="btn btn-sm btn-secondary mt-3 "
                              >
                                Cancel
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modifiersmange;
